import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import Login from "./views/Login";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/sponsor",
      name: "sponsor",
      component: () => import("./views/Sponsor.vue")
    },
    {
      path: "/member",
      name: "member",
      component: () => import("./views/Member.vue")
    },
    {
      path: "/admin",
      name: "admin",
      component: () => import("./views/Admin.vue")
    },
    {
      path: "/",
      name: "login",
      component: Login
    }
  ]
});

export default router;

router.beforeEach((to, from, next) => {
  if (store.state.memberLoggedIn && to.name != "member") {
    next("/member");
  } else if (store.state.sponsorLoggedIn && to.name != "sponsor") {
    next("/sponsor");
  } else if (store.state.adminLoggedIn && to.name != "admin") {
    next("/admin");
  } else if (
    to.name != "login" &&
    !store.state.memberLoggedIn &&
    !store.state.sponsorLoggedIn &&
    !store.state.adminLoggedIn
  ) {
    next("/");
  } else {
    next();
  }
});
